import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import WhatIs from '@/pages/home/components/WhatIs';
import WhyChoose from '@/pages/home/components/WhyChoose';
import ProductCategories from '@/pages/home/components/ProductCategories';
import HowItWorks from '@/pages/home/components/HowItWorks';
import SafetyCenter from '@/pages/home/components/SafetyCenter';
import FAQ from '@/pages/home/components/FAQ';
import ArticlePreview from '@/pages/home/components/ArticlePreview';

const siteUrl = import.meta.env.VITE_SITE_URL;

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Polska',
  url: siteUrl,
  description: 'Kakobuy Spreadsheet Polska – Najlepsza lista produktów i znalezisk. Odkrywaj sneakersy, ubrania, akcesoria i popularne produkty z Chin w jednym miejscu.',
  inLanguage: 'pl-PL',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kakobuy Polska',
  url: siteUrl,
  description: 'Najlepsze źródło informacji o Kakobuy Spreadsheet w Polsce.',
  logo: `${siteUrl}/favicon.png`,
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Strona główna',
      item: `${siteUrl}/`,
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }
  }, [location.hash]);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homepageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <Hero />
          <WhatIs />
          <WhyChoose />
          <ProductCategories />
          <HowItWorks />
          <SafetyCenter />
          <ArticlePreview />
          <FAQ />
        </main>

        <Footer />
      </div>
    </>
  );
}